export default "__VITE_ASSET__e731a046__"